import ErpCrud from "@/components/ErpCrud";

export default function AdminWarranties() {
  return (
    <ErpCrud
      testid="admin-warranties"
      title="Warranties"
      subtitle="Product warranty records — app ke saath 2-way synced"
      endpoint="/admin/warranties"
      fields={[
        { key: "product_name", label: "Product", type: "text" },
        { key: "customer_name", label: "Customer", type: "text" },
        { key: "customer_phone", label: "Phone", type: "text" },
        { key: "serial_no", label: "Serial / IMEI", type: "text" },
        { key: "start_date", label: "Start Date", type: "date" },
        { key: "months", label: "Warranty (months)", type: "number" },
        { key: "order_id", label: "Order / Invoice", type: "text" },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "product_name", label: "Product" },
        { key: "customer_name", label: "Customer" },
        { key: "serial_no", label: "Serial" },
        { key: "start_date", label: "Start" },
        { key: "expiry_date", label: "Expires" },
      ]}
    />
  );
}
